import React from 'react';

/** Purpose: Renders destination-provider inputs for existing/new selection. Inputs: props object. Output: React render output (JSX). */
function DestinationProviderFields({
  mode,
  setMode,
  selectedProviderId,
  setSelectedProviderId,
  newDestination,
  setNewDestination,
  providerOptions
}) {
  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => setMode('existing')}
          className={`px-3 py-1.5 text-sm rounded-lg border ${mode === 'existing' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-700 border-slate-300'}`}
        >
          Existing Provider
        </button>
        <button
          type="button"
          onClick={() => setMode('new')}
          className={`px-3 py-1.5 text-sm rounded-lg border ${mode === 'new' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-700 border-slate-300'}`}
        >
          New Provider
        </button>
      </div>

      {mode === 'existing' ? (
        <select
          value={selectedProviderId}
          onChange={(event) => setSelectedProviderId(event.target.value)}
          className="w-full px-3 py-2 border border-slate-300 rounded-lg"
        >
          <option value="">Select destination provider</option>
          {providerOptions.map((provider) => (
            <option key={provider.id} value={provider.id}>
              {provider.name} - {provider.organization}
            </option>
          ))}
        </select>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <input
            type="text"
            placeholder="Provider name *"
            value={newDestination.name}
            onChange={(event) => setNewDestination((prev) => ({ ...prev, name: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="Title"
            value={newDestination.title}
            onChange={(event) => setNewDestination((prev) => ({ ...prev, title: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="Organization *"
            value={newDestination.organization}
            onChange={(event) => setNewDestination((prev) => ({ ...prev, organization: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg md:col-span-2"
          />
          <input
            type="email"
            placeholder="Email"
            value={newDestination.email}
            onChange={(event) => setNewDestination((prev) => ({ ...prev, email: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="Phone"
            value={newDestination.phone}
            onChange={(event) => setNewDestination((prev) => ({ ...prev, phone: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
        </div>
      )}
    </div>
  );
}

export default DestinationProviderFields;
